import { ComponentService } from "../Services/Axios/Api";
import { generateDynamicCSS } from "../ComponentsMap";

class Layout {
    data = {};
    constructor() {
        this.data = {
            id: '3',
            ComponentName: 'Layout',
            buttons: {
                shape: 'normal',
                CTAPrimaryButton: {
                    backgroundColor: '#007bff',
                    color: '#ffffff',
                },
                CTAPrimaryButtonHover: {
                    backgroundColor: '#0069d9',
                    color: '#ffffff'
                },
                CTASecondaryButton: {
                    backgroundColor: '#6c757d',
                    color: '#ffffff',
                },
                CTASecondaryButtonHover: {
                    backgroundColor: '#5a6268',
                    color: '#ffffff'
                }
            },
            headers: {
                h1: '#212529',
                h2: '#212529',
                h3: '#212529',
                h4: '#212529',
                h5: '#212529',
                h6: '#212529'
            },
            fonts: []
        };
    }

    // ID
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Component Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(name) { this.data.ComponentName = name; }

    // Buttons
    getButtons() { return this.data.buttons; }
    setButtons(buttons) { this.data.buttons = buttons; }

    renderButtonStyle() {
        switch (this.data.buttons.shape) {
            case "normal":
                generateDynamicCSS("CTAButton", [{ borderRadius: "0px" }]);
                break;
            case "rounded":
                generateDynamicCSS("CTAButton", [{ borderRadius: "10px" }]);
                break;
            case "oval":
                generateDynamicCSS("CTAButton", [{ borderRadius: "25px" }]);
                break;
            default:
                generateDynamicCSS("CTAButton", [{ borderRadius: "0px" }]);
                break;
        }

        const { CTAPrimaryButton, CTAPrimaryButtonHover, CTASecondaryButton, CTASecondaryButtonHover } = this.data.buttons;
        
        generateDynamicCSS("CTAPrimaryButton", [CTAPrimaryButton]);
        generateDynamicCSS("CTAPrimaryButtonHover", [CTAPrimaryButtonHover]);
        generateDynamicCSS("CTASecondaryButton", [CTASecondaryButton]);
        generateDynamicCSS("CTASecondaryButtonHover", [CTASecondaryButtonHover]);
    }

    getButtonShape() { return this.data.buttons.shape; }
    setButtonShape(shape) { this.data.buttons.shape = shape; }

    // Updated button getters/setters for new structure
    getPrimaryButton() { 
        return {
            normal: this.data.buttons.CTAPrimaryButton,
            hover: this.data.buttons.CTAPrimaryButtonHover
        };
    }

    setPrimaryButton(primary) { 
        this.data.buttons.CTAPrimaryButton = primary.normal || this.data.buttons.CTAPrimaryButton;
        this.data.buttons.CTAPrimaryButtonHover = primary.hover || this.data.buttons.CTAPrimaryButtonHover;
    }

    getSecondaryButton() { 
        return {
            normal: this.data.buttons.CTASecondaryButton,
            hover: this.data.buttons.CTASecondaryButtonHover
        };
    }

    setSecondaryButton(secondary) { 
        this.data.buttons.CTASecondaryButton = secondary.normal || this.data.buttons.CTASecondaryButton;
        this.data.buttons.CTASecondaryButtonHover = secondary.hover || this.data.buttons.CTASecondaryButtonHover;
    }

    // Headers
    getHeaders() { return this.data.headers; }
    setHeaders(headers) { this.data.headers = headers; }

    getHeaderColor(level) { return this.data.headers[level]; }
    setHeaderColor(level, color) { this.data.headers[level] = color; }

    getFonts() { return this.data.fonts || []; }
    setFonts(fonts) { this.data.fonts = fonts || []; }

    getFont(language) { 
        const found = this.getFonts().find(font => font.language === language);
        return found?.font || '';
    }

    setFont(language, font) { 
        const normalizedFont = typeof font === 'string' ? { family: font } : font;
        const fonts = [...this.getFonts()];
        const existing = fonts.find(item => item.language === language);
        if (existing) {
            existing.font = normalizedFont;
        } else {
            fonts.push({ language, font: normalizedFont });
        }
        this.setFonts(fonts);
        return fonts;
    }

    syncFontsWithLanguages(availableLanguages = [], defaultFont = '') {
        const fonts = [...this.getFonts()];
        availableLanguages.forEach(lang => {
            const exists = fonts.find(item => item.language === lang.code);
            if (!exists) {
                fonts.push({
                    language: lang.code,
                    font: typeof defaultFont === 'string' ? { family: defaultFont } : defaultFont
                });
            }
        });
        this.setFonts(fonts);
        return fonts;
    }

    // Data operations
    getData() { return this.data; }
    setData(data) { 
        this.data = { ...this.data, ...data };
        if (!this.data.fonts) {
            this.data.fonts = [];
        }
    }

    async load() {
        try {
            const response = await ComponentService.getComponent(this.data.ComponentName);
            const data = JSON.parse(response[0]?.data);
            this.setData(data);
            this.setId(response[0]?.id);
            this.renderButtonStyle();
            return data;
        } catch (error) {
            throw new Error(error.response?.data || 'Failed to load layout data');
        }
    }

    async save() {
        try {
            const response = await ComponentService.SaveData(this.getId(), this.getData());
            return response;
        } catch (error) {
            throw new Error(error.response?.data || 'Failed to save layout data');
        }
    }
}

export const createLayoutInstance = () => new Layout();